




















































































































import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import ShiftDto from '@/models/Shifts/ShiftDto';
import GiganautVue from '@/components/Shared/GiganautVue';
import ShiftBookedStatus from '@/components/Shifts/Display/ShiftBookedStatus.vue';
import ShiftStatus from '@/components/Shifts/Display/ShiftStatus.vue';
import BookingBookedWorkersEmail from '@/components/BookingRoleWorkers/BookingBookedWorkersEmail.vue';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue';
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import BookingTimesheetEdit from '@/components/Timesheets/BookingTimesheetEdit.vue';
import JourneyDetails from '@/components/Timesheets/Display/JourneyDetails.vue';
import TimesheetStatus from '@/models/Timesheets/TimesheetStatus';

@Component({
  name: 'BookingBookedWorkers',
  components: { ShiftStatus, ShiftBookedStatus, BookingBookedWorkersEmail, BookingRoleWorkerShiftStatus, BookingTimesheetEdit, JourneyDetails }
})
export default class extends GiganautVue {

	@Prop()
	selectedBookingRole: BookingRoleDto;

	timesheetStatus = TimesheetStatus

	get currentBooking() {
		return BookingDetailsModule.currentBooking;
	}

	@Watch('selectedBookingRole', { immediate: true })
    async onSelectedBookingRoleChanged(val: BookingRoleDto, oldVal: BookingRoleDto) {
		BookingDetailsModule.updateBookedSelectedBookingRole(val);
	}

	async updateSelectedShift(shift: ShiftDto) {
        await BookingDetailsModule.updateBookedSelectedShift(shift);
    }

	get shifts() {
		return BookingDetailsModule.bookedWorkersVM.shifts;
	}

	get timesheets() {
		return BookingDetailsModule.bookedWorkersVM.timesheets;
	}
}
